import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { ForgPassword } from "@unisearch/auth/forgot-password";

const Forgot = () => {
  return (
    <LayoutMain
      title="Forget Password"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/forgot-password`}
    >
      <ForgPassword />
    </LayoutMain>
  );
};

export default Forgot;
